export enum AutomatedARManagementStatus {
  ON = 'on',
  OFF = 'off',
  ERROR = 'error',
  NULL = 'null',
}
